export const apiURL = (url: string) => {
  const apiUrl = import.meta.env.VITE_API_URL;
  console.info('apiURL', { apiUrl, url });
  const out = new URL(url, apiUrl);
  return out.href;
};

export default apiURL;